export default "__VITE_ASSET__05a6f43b__"